import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getDynamicDataList } from '../../../../../services/api';
import Observer from '@researchgate/react-intersection-observer';
import styles from './index.css';
import Module from '../../module';

class Health extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        dataListArr: [],
    };

    async getDataListFn() {
        try {
            const dataListArr = await getDynamicDataList('12-', 11);

            this.setState({
                dataListArr,
            });
        } catch (e) {
            console.error(e);
        }
    }

    handleChange = (event, unobserve) => {
        const { content } = this.props;
        const { isAsync } = content;

        if (event.isIntersecting) {
            unobserve();
            if (isAsync) {
                this.getDataListFn();
            }
        }
    };

    render() {
        const { content } = this.props;
        const { dataListArr } = this.state;
        const { healthMd, healthSlide, healthRecommendFeed, healthAd, isAsync } = content;

        const normalTabsData = healthMd;
        const viewMoreLinkData = (healthMd && healthMd.moreTh) || '';
        const newsStreamData = isAsync ? dataListArr : healthRecommendFeed;
        const mdBannerData = healthSlide;

        if (normalTabsData) {
            normalTabsData.chipConfig = {
                id: '50173',
                type: 'struct',
                title: '健康子导航数据',
                groupName: 'content',
                translate: 'handleHomeHealthMdInfo',
            };
        }
        if (mdBannerData) {
            mdBannerData.chipConfig = {
                id: '135130',
                type: 'recommend',
                title: '健康焦点图数据',
                groupName: 'content',
                translate: 'handleHomeHealthSlideInfo',
            };
        }
        const newsStreamChipConfig = {
            id: '75207',
            type: 'recommend',
            title: '健康信息流推荐数据',
            groupName: 'content',
            translate: 'handleHomehealthRecommendFeedInfo',
        };

        const moduleData = {
            normalTabsData,
            newsStreamChipConfig,
            feedAd: healthAd,
            mdBannerData,
            newsStreamData,
            viewMoreLinkData,
        };

        return (
            <Observer onChange={this.handleChange}>
                <section className={styles.health}>
                    <Module content={moduleData} />
                </section>
            </Observer>
        );
    }
}

export default errorBoundary(Health);
